import { render, staticRenderFns } from "./WeeklyPerf.vue?vue&type=template&id=07ef3b53&scoped=true&"
import script from "./WeeklyPerf.vue?vue&type=script&lang=js&"
export * from "./WeeklyPerf.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyPerf.vue?vue&type=style&index=0&id=07ef3b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ef3b53",
  null
  
)

export default component.exports